import { iFormConfigItem, isNotEmptyArray } from "../../core/formValidation";

export interface iFeaturedContentValidationData {
    data: number[];
}

export const featuredContentValidationConfig: iFormConfigItem<iFeaturedContentValidationData>[] = [
    { field: "data", validationCheckers: [isNotEmptyArray] }
];